import styles from './Tabs.module.scss'
import { Variant, VariantUnion } from './Constants'

const getVariantAsEnum = (variant: VariantUnion): Variant => {
	switch (variant) {
		case 'darkBackground':
			return Variant.DarkBackground
		case 'grayBackground':
			return Variant.GrayBackground
		case 'lightBackground':
			return Variant.LightBackground
		default:
			return Variant.DarkBackground
	}
}

type Props = {
	title: string
	value: number
	onClick: (value: number) => void
	selected: boolean
	testId?: string
	variant: VariantUnion
	fullWidth?: boolean
	fullWidthMobile?: boolean
}

const Tab = ({
	title,
	value,
	onClick,
	selected,
	testId,
	variant,
	fullWidth = true,
	fullWidthMobile = true,
}: Props): JSX.Element => {
	const buttonClasses = `${styles.tabButton} ${selected ? styles.selected : ''} ${styles[getVariantAsEnum(variant)]} ${
		fullWidth ? styles.fullWidth : ''
	} ${fullWidthMobile ? styles.fullWidthMobile : ''}`
	const titleClasses = `${styles.tabTitle} ${selected ? styles.selectedTitle : ''}`

	return (
		<button className={buttonClasses} onClick={() => onClick(value)} data-testid={`${testId}-${value}`} tabIndex={0}>
			<span className={titleClasses}>{title}</span>
		</button>
	)
}

export default Tab
